export default __webpack_public_path__ + "static/media/Ki.e694402d.ttf";